(function(){
  'use strict';
  
  function initCustomerAccessControl(config) {
    let popupShown = false;
    
    function init() {
      replacePrices(config);
      disableAddToCart(config);

      if (isCollectionPage()) {
        initScrollPopup(config);
      }
    }
    
    function replacePrices(config) {
      const priceSelectors = [
        '.price',
        '.money', 
        '.glc-money',
        '[data-price]',
        '.price-item',
        '.product__price',
        '.product-single__price'
      ];
      
      priceSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          if (el.textContent.trim() !== '' && !el.dataset.priceReplaced) {
            el.dataset.priceReplaced = 'true';
            el.innerHTML = '<span onclick="window.location.href=\'/pages/hesabim?return_url=' + config.returnUrl + '\'" style="cursor:pointer;text-decoration:underline;color:#007cba;">' + config.loginText + '</span>';
          }
        });
      });
    }

    function disableAddToCart(config) {
      const buttonSelectors = [
        'button[name="add"]',
        'button[type="submit"]',
        '.add-to-cart',
        '.product-form__submit',
        '.btn--add-to-cart',
        '[data-add-to-cart]',
        'form[action*="/cart/add"] button[type="submit"]',
        'form[action*="/cart/add"] input[type="submit"]',
        // Koleksiyon sayfasi quick-add butonu (quickview / tek tikla sepete ekle)
        '.js-quick-add',
        '.quick-add-btn',
        '[data-quickview-handle]'
      ];

      buttonSelectors.forEach(selector => {
        const buttons = document.querySelectorAll(selector);
        buttons.forEach(button => {
          if (!button.dataset.cartDisabled) {
            button.dataset.cartDisabled = 'true';
            button.disabled = true;
            button.style.opacity = '0.5';
            button.style.cursor = 'not-allowed';

            const originalText = button.innerHTML;
            button.innerHTML = 'Giriş Yapınız';

            button.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              window.location.href = '/pages/hesabim?return_url=' + config.returnUrl;
              return false;
            }, true);
          }
        });
      });
    }

    function isCollectionPage() {
      return document.body.classList.contains('template-collection') ||
             window.location.pathname.includes('/collections/') ||
             document.querySelector('[data-section-type="collection"]') ||
             document.querySelector('.collection-page') ||
             document.querySelector('.collection-template') ||
             document.querySelector('[data-template="collection"]');
    }
    
    function initScrollPopup(config) {
      if (popupShown) return;
      
      function checkScroll() {
        const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
        
        if (scrollPercent >= 50 && !popupShown) {
          showPopup(config);
          popupShown = true;
          window.removeEventListener('scroll', checkScroll);
        }
      }
      
      window.addEventListener('scroll', checkScroll);
    }
    
    function showPopup(config) {
      const popup = document.createElement('div');
      popup.innerHTML = `
        <div id="access-popup-overlay" style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);z-index:99999;display:flex;align-items:center;justify-content:center;">
          <div id="access-popup-content" style="background:white;padding:40px;border-radius:12px;text-align:center;max-width:420px;margin:20px;box-shadow:0 20px 60px rgba(0,0,0,0.3);">
            <h3 style="margin:0 0 15px 0;font-size:20px;color:#333;font-weight:600;">${config.popupMessage}</h3>
            <p style="margin:0 0 25px 0;color:#666;font-size:15px;line-height:1.5;">Devam etmek için giriş yapmanız gerekmektedir.</p>
            <button onclick="window.location.href='/pages/hesabim?return_url=${config.returnUrl}'" style="background:linear-gradient(135deg,#667eea 0%,#764ba2 100%);color:white;border:none;padding:15px 35px;border-radius:8px;cursor:pointer;font-size:16px;font-weight:600;">Giriş Yap</button>
          </div>
        </div>
      `;
      
      document.body.appendChild(popup);
    }
    
    function ready(fn) {
      if (document.readyState !== 'loading') {
        fn();
      } else {
        document.addEventListener('DOMContentLoaded', fn);
      }
    }
    
    ready(init);
    
    const observer = new MutationObserver(() => {
      setTimeout(() => {
        replacePrices(config);
        disableAddToCart(config);
      }, 100);
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  window.initCustomerAccessControl = initCustomerAccessControl;
})();